import React from 'react'
import { Menu } from 'antd'

import type { LntMenuProps } from './types'

export const LntMenu: React.FC<LntMenuProps> = props => {
  const { children, ...restProps } = props
  return <Menu { ...restProps }>{ children }</Menu>
}
